import React from 'react';
import { CardVariants, Text } from '@clockout-dev/design-elements';
import MetricCard from '../../common/metricCard/MetricCard';
import CurrencyCircleIcon from '../../common/currencyCircleIcon/CurrencyCircleIcon';
import TeamIcon from '../../common/teamIcon/TeamIcon';
import OverdueClockIcon from '../../common/overdueClockIcon/OverdueClockIcon';
import HistoryClockIcon from '../../common/historyClockIcon/HistoryClockIcon';
import KpiDeltaPill from './KpiDeltaPill';
import { formatCompactCurrency, formatDays } from '../../../utils/numbers';
import styles from './styles/kpiRow.module.scss';

/**
 * KPI row rendered when the Fee GL tab is active (Figma 5679-6621).
 *
 * Pure presentational — same four-tile layout as the Advance row but
 * with Fee-specific labels and a `KpiDeltaPill` in every action slot
 * (no actionable buttons here). Highlight tile uses the `MetricCard`
 * HIGHLIGHT variant for the gradient chrome. Icons live in `common/`
 * so they can be reused on other screens.
 */
function KpiFeeRow({ data }) {
    const totalInflows = data?.totalInflows;
    const totalInflowsDelta = data?.totalInflowsDelta;
    const incomingFeesNext7Days = data?.incomingFeesNext7Days;
    const incomingFeesNext7DaysDelta = data?.incomingFeesNext7DaysDelta;
    const overdueFees = data?.overdueFees;
    const overdueFeesDelta = data?.overdueFeesDelta;
    const averageOverdueDays = data?.averageOverdueDays;
    const averageOverdueDaysDelta = data?.averageOverdueDaysDelta;

    return (
        <div className={styles.row}>
            <MetricCard
                variant={CardVariants.HIGHLIGHT}
                image={<CurrencyCircleIcon />}
                action={<KpiDeltaPill delta={totalInflowsDelta} />}>
                <div className={styles.cardContent}>
                    <Text size="xs" className={styles.cardLabelHighlight}>Total Fee Inflows</Text>
                    <Text size="display-s" className={styles.cardContent}>{formatCompactCurrency(totalInflows)}</Text>
                </div>
            </MetricCard>
            <MetricCard
                image={<TeamIcon />}
                action={<KpiDeltaPill delta={incomingFeesNext7DaysDelta} />}>
                <div className={styles.cardContent}>
                    <Text size="xs" className={styles.cardLabel}>Incoming Fees (Next 7 Days)</Text>
                    <Text size="display-s" className={styles.cardContent}>{formatCompactCurrency(incomingFeesNext7Days)}</Text>
                </div>
            </MetricCard>
            <MetricCard
                image={<OverdueClockIcon className={styles.iconDanger} />}
                classNames={{ icon: styles.iconBackground }}
                action={<KpiDeltaPill delta={overdueFeesDelta} />}>
                <div className={styles.cardContent}>
                    <Text size="xs" className={styles.cardLabel}>Overdue Fees</Text>
                    <Text size="display-s" className={styles.cardContent}>{formatCompactCurrency(overdueFees)}</Text>
                </div>
            </MetricCard>
            <MetricCard
                image={<HistoryClockIcon />}
                action={<KpiDeltaPill delta={averageOverdueDaysDelta} />}>
                <div className={styles.cardContent}>
                    <Text size="xs" className={styles.cardLabel}>Average Overdue</Text>
                    <Text size="display-s" className={styles.cardContent}>{formatDays(averageOverdueDays)}</Text>
                </div>
            </MetricCard>
        </div>
    );
}

export default KpiFeeRow;
